import { useContext, createContext } from 'react'

export const TemplateFormContext = createContext(null)

export const useTemplateFormContext = () => {
  return useContext(TemplateFormContext)
}
